// extracted by mini-css-extract-plugin
export default {"button_more":"ButtonMore_button_more__VlhTc"};